import { t } from '@/i18n/utils'

/**
 * Subscribe 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  get membership() { return t('Membership') },
  get vipMembership() { return t('VIPMembership') },
  get membershipDesc() { return t('VIPIncentive2') },
  get notJoinedYet() { return t('Identification') },
  // 与 en.json 不完全匹配
  get tips() { return t('subscriptionTips') },
  // 与 en.json 不完全匹配（格式不同）
  get tip1() { return t('subscriptionTip1') },
  // 与 en.json 不完全匹配（格式不同）
  get tip2() { return t('subscriptionTip2') },
  // 与 en.json 不完全匹配
  get free() { return t('subscriptionFree') },
  get buyNow() { return t('BuyNow') },
  // 与 en.json 不完全匹配（占位符格式不同）
  payTemplateGetCoins(coins: string) { return t('payTemplateGetCoins', { coins }) },
  // 与 en.json 不完全匹配（占位符格式不同）
  payTemplateEarnCoins(coins: string, daily: string) { return t('payTemplateEarnCoins', { coins, daily }) },
} as const
